import React, { ChangeEvent } from 'react';
import { Control, useController } from 'react-hook-form';
import styled from 'styled-components';

interface TextFieldControllerProps {
  className?: string;
  control: Control;
  name: string;
  disabled?: boolean;
  rows?: number;
  required?: boolean;
  placeholder?: string;
  onChange?: (value: string) => void;
}

function TextFieldController({
  className,
  control,
  name,
  disabled = false,
  rows,
  required = false,
  placeholder = '',
  onChange,
}: TextFieldControllerProps) {
  const {
    field,
    meta: { invalid },
  } = useController({
    name,
    control,
    rules: { required: required },
  });

  // 공통으로 사용하는 field props를 하나의 객체로 묶기
  const fieldProps = {
    onBlur: field.onBlur,
    value: field.value,
    name: field.name,
    ref: field.ref,
  };

  const handleChange = (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    field.onChange(event.target.value);
    if (!!onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <StyledTextFieldController className={className}>
      {!!rows ? (
        <textarea
          className="textFieldController__input textarea"
          disabled={disabled}
          rows={rows}
          placeholder={placeholder}
          onChange={handleChange}
          {...fieldProps}
        />
      ) : (
        <input
          className="textFieldController__input input"
          type="text"
          disabled={disabled}
          placeholder={placeholder}
          onChange={handleChange}
          {...fieldProps}
        />
      )}
      {invalid && <span style={{ color: 'red' }}>This field is required</span>}
    </StyledTextFieldController>
  );
}

const StyledTextFieldController = styled.div`
  .textFieldController__input {
    width: 100%;
    border-radius: 2px;
    border: 1px solid #e1e1e7;
    padding: 12px;
    font-size: 20px;
    font-weight: 400;
    color: #222;
    &.input {
      height: 50px;
    }
    &.textarea {
      height: 150px;
      resize: none;
    }
    &:disabled {
      background: #f9f9fb;
      color: #888;
    }
    &::placeholder {
      color: #aaa;
    }
  }
`;

export default TextFieldController;
